import { useEffect, useState } from "react";
import WizardModal2 from "../../wizard-modal/wizard-modal.component2.jsx";
import WizardModalStep from "../../wizard-modal-order/wizard-modal-step/wizard-modal-step.component";

import ConfirmOrder from "../confirm-order/confirm-order";
import { ReactComponent as CloseIcon } from "../../../icons/close.svg";
import BackArrow from "../../back-arrow/back-arrow.component";
import {
  CMCloseButton,
  CMwizardOrder,
  CMTitleStyle,
  CMwizardConfirmOrder,
  CMBackArrow,
  OrderPrice,
  CMwizardIssuer,
} from "./place-order.styles";
import OrderPreview from "../order-preview/order-preview";
import { useMediaQuery } from "@mui/material";
import {
  getPairBalance,
  getPairList,
  getPairNotify,
} from "../../../Services/prod/auth.service";
import BuyModal from "../buy-modal/buy-modal.jsx";
import { useAuth } from "../../../Contexts/auth.context.jsx";
import IssuerOrder from "../order-preview/issuer-modal-component.jsx";
import OrderConfirmed from "../../place-bid/order-confirmed/order-confirmed.jsx";
import { CMwizardOrderConfirmed } from "../../place-bid/place-bid/place-bid.styles.jsx";
const PlaceBid = ({ open, handleClose, auction, setTradeError,getPriceIncrease ,updateGraph,setUpdateGraph,financials,setFinancials }) => {
  const { auth } = useAuth();
  const [activeStep, setActiveStep] = useState(1);
  const isMobile = useMediaQuery("(max-width:992px)");
  const [editValues, setEditValues] = useState({});
  const [pairBalance, setPairBalance] = useState();
  const [pairFees, setPairFees] = useState();
  const [update, setUpdate] = useState(false);
  const [issuerPair, setIssuerPair] = useState(false)
  const [issuerData, setIssuerData] = useState([]);
  const [side, setSide] = useState(0)
  const [isEdit, setIsEdit] = useState(false)
  const [orderTotal, setOrderTotal] = useState('')

  const handleNext = (orderValues) => {
    setEditValues(orderValues);
    setActiveStep((value) => value + 1);
  };

  const handlePrev = () => {
    setActiveStep((value) => value - 1);
  };

  const handleClosed = () => {
    if (issuerPair) {
      setActiveStep(0)
    } else {

      setActiveStep(1);
    }
    setEditValues({});
    handleClose(); // Set a value that indicates the wizard is closed
    activeStep==3  && getPriceIncrease();
    activeStep==3  && setUpdateGraph(!updateGraph);
    activeStep==3  && setFinancials(!financials);
    

  };
  // PAIR BALANCE FUNCTION
  const getPairBalanceData = async () => {
    try {
      const resPairBalance = await getPairBalance(
        `${auction?.symbol?.toUpperCase()}_USD`
      );
      setPairBalance(resPairBalance?.data);
      setTradeError(resPairBalance);
    } catch (error) {
      console.log(error);
    }
  };
  // PAIR FEES FUNCTION
  const getPairFees = async () => {
    try {
      const resPairFees = await getPairList();
      const matchedPair = resPairFees?.data?.pairList?.find(
        (ele) => ele?.pair_name === auction?.symbol?.toLowerCase() + "_usd"
      );
      setPairFees(matchedPair);
      if (matchedPair?.user_id === Number(auth?.userId) && activeStep !== 3) {
        setIssuerPair(true)
        setActiveStep(0)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPairNotification = async () => {
    try {
      const data = await getPairNotify(`${auction?.symbol?.toUpperCase()}_USD`)
      if (data) {
        setIssuerData(data?.data)
      }
    } catch (error) {
      console.log(error)
    }
  }
  // CALL BOTH FUNCTIONS
  useEffect(() => {
    getPairBalanceData();
    getPairFees();
    getPairNotification()
  }, [update]);

  useEffect(() => {
    if (issuerData?.rows?.length > 0) {
      const buyData = issuerData?.rows?.find((e) => e.side === 0)
      const sellData = issuerData?.rows?.find((e) => e.side === 1)
      if (buyData && side === 0) {
        setIsEdit(true)
      } else if (sellData && side === 1) {
        setIsEdit(true)
      } else if (buyData && sellData) {
        setIsEdit(true)
      } else (
        setIsEdit(false)
      )

    }

  }, [issuerData, side])

  return (
    <>
      <WizardModal2 className="box-sizing" open={open} onClose={handleClose}>
        <CMCloseButton onClick={handleClosed}>
          { <CloseIcon width={16} height={16} />}
        </CMCloseButton>
        <CMBackArrow onClick={handleClosed}>
          {isMobile && <BackArrow width={16} height={16} />}
        </CMBackArrow>
        {
          {
            0: (
              <WizardModalStep
                style={CMwizardIssuer}
                title={`Confirm Notification for ${auction.symbol}`}
                titleStyle={CMTitleStyle}
              >
                <div style={OrderPrice}>
                  <IssuerOrder
                    handleNext={handleNext}
                    auction={auction}
                    editValues={editValues}
                    pairBalance={pairBalance}
                    pairFees={pairFees}
                    issuerData={issuerData}
                    side={side}
                    setSide={setSide}
                    isEdit={isEdit}
                    setActiveStep={setActiveStep}
                    setUpdate={setUpdate}
                    getPairNotification={getPairNotification}
                  />
                </div>
              </WizardModalStep>
            ),
            1: (
              <WizardModalStep
                style={CMwizardOrder}
                title="Place an order"
                titleStyle={CMTitleStyle}
              >
                <div style={OrderPrice}>
                  <OrderPreview
                    handleNext={handleNext}
                    auction={auction}
                    editValues={editValues}
                    pairBalance={pairBalance}
                    pairFees={pairFees}
                  />
                </div>
              </WizardModalStep>
            ),
            2: (
              <WizardModalStep
                style={CMwizardConfirmOrder}
                title={`Confirm ${
                  editValues?.selectedOption === "Buy" ? "buy" : "sell"
                } order`}
                titleStyle={CMTitleStyle}
              >
                <div>
                  <ConfirmOrder
                    handleNext={handleNext}
                    handlePrev={handlePrev}
                    editValues={editValues}
                    auction={auction}
                    pairBalance={pairBalance}
                    pairFees={pairFees}
                    update={update}
                    setUpdate={setUpdate}
                    setActiveStep={setActiveStep}
                    setOrderTotal={setOrderTotal}
                    issuerPair={issuerPair}
                  />
                </div>
              </WizardModalStep>
            ),
            3: (
              <WizardModalStep
                title={editValues?.selectedPriceOption === "Limit" ? "Order Submitted": "Order Executed"}
                style={CMwizardOrderConfirmed}
                titleStyle={CMTitleStyle}
              >
                <OrderConfirmed
                  orderText={editValues?.selectedPriceOption === "Market"?"":"Your order has been placed successfully!"}
                  orderInform={editValues?.selectedOption === "Buy" && editValues?.selectedPriceOption === "Limit" ? `Amount of $${orderTotal} of your Available Cash had been temporarily restricted to support your order.` : editValues?.selectedOption === "Buy" && editValues?.selectedPriceOption === "Market" ? `Order has been successfully matched. Please check order history for more details.` : editValues?.selectedOption === "Sell" && editValues?.selectedPriceOption === "Market" ? `Order has been successfully matched. Please check order history for more details.`: `The required ${editValues?.quantity} units had been temporarily restricted to support your order.`}
                  orderInform2={editValues?.selectedOption === "Buy" ? `Once your order will be successfully matched your portfolio will be credited with the appropriate purchased units and your Cash Balance will be debited.` : "Once your order will be successfully matched you will no longer own the units and your portfolio Available Cash will be credited (net of fees)."}
                  linkText="/portfolio"
                  orderType={editValues?.selectedPriceOption}
                  type={editValues?.selectedOption}
                  issuerPair={issuerPair}
                />
              </WizardModalStep>
            ),
          }[activeStep]
        }
      </WizardModal2>
    </>
  );
};
export default PlaceBid;
